import styled, { keyframes } from 'styled-components';
import { zoomIn } from 'react-animations';
import { campoBase, rotuloFlutuante, rotuloFlutuanteAtivo } from '../../styles/campo';

const animationType = keyframes`${zoomIn}`;

interface IProps {
  $animated?: boolean;
  $comIcone?: boolean;
}

export const Container = styled.div<IProps>`
  position: relative;
  width: 100%;
  animation: 0.5s ${({ $animated }) => ($animated ? animationType : 'none')};

  input {
    ${campoBase}
    padding-right: ${({ $comIcone }) => ($comIcone ? '44px' : '12px')};
  }

  label {
    ${rotuloFlutuante}
  }

  input:not(:placeholder-shown) + label,
  input:focus + label,
  input[type='date'] + label {
    ${rotuloFlutuanteAtivo}
  }

  input:focus + label {
    color: ${({ theme }) => theme.cores.primary};
  }

  .obrigatorio {
    color: ${({ theme }) => theme.cores.critical};
    margin-left: 2px;
  }
`;

export const BotaoIcone = styled.button`
  position: absolute;
  right: 4px;
  top: 4px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: ${({ theme }) => theme.raio.sm};
  background: transparent;
  color: ${({ theme }) => theme.cores.inkSecondary};

  &:hover {
    background-color: ${({ theme }) => theme.cores.surface};
    color: ${({ theme }) => theme.cores.ink};
  }
`;
